<template>
  <div class="content">
    <h1 v-if='is_staff'> Hello Admin</h1>
    <h1 v-if='!is_staff'> Hello {{get_userdata.email}}</h1>
    <h1 v-if='!is_staff'> Streams </h1>
    <h3 v-if='!is_staff'>       
      <span v-if="get_sources.length > 0">Current websites </span> 
      <span v-else>Contact the admin area with your website to start using stats <a href="#footer"> Contact me</a></span> 
      
      </h3>
    <div v-if='!is_staff' >
            <md-table table-header-color="blue">
            <md-table-row slot="md-table-row" v-for="item in get_sources">              
                <md-table-cell md-label="User">{{ item }}</md-table-cell>                
            </md-table-row>
            </md-table>
      </div>
    <div class="md-layout">
      
       <div class="md-layout-item md-medium-size-100 md-xsmall-size-100 md-size-100" v-if="is_authenticated && is_staff==false">
        <stats-card data-background-color="black">
          <template slot="header">
            <md-icon>people</md-icon>
          </template>

          <template slot="content">
            <p class="category">People Online in the last 20 minutes</p>
            <h3 class="title">
              {{people_by_user["clients"]}}
              <small>Peers</small>
            </h3>
          </template>
        </stats-card>
      </div>
      <div class="md-layout-item md-medium-size-100 md-xsmall-size-100 md-size-100" v-if="is_staff && people.length > 1">
        <chart-card
                :chart-data="PeopleOnline"
                :chart-options="PeopleOnlineOptions"
                :chart-type="'Line'"
                data-background-color="blue">
          <template slot="content">
            <h4 class="title">
              <strong>{{people[0].people}}</strong> People Online!! </h4>
            <p class="category">

            </p>
          </template>

          <template slot="footer">
            <div class="stats">
              <md-icon>people_alt</md-icon>
              Last update 2 minutes ago
            </div>
          </template>
        </chart-card>
      </div>



      <div class="md-layout-item md-medium-size-100 md-xsmall-size-100 md-size-100">
        <md-card>
          <md-card-header data-background-color="orange">
            <h4 class="title">Streams</h4>
            <p class="category">Streams online</p>
            <small>
              <div class="stats">
                <md-icon>done</md-icon>
                Clink on swarm to check more stats
              </div>
            </small>
          </md-card-header>
          <md-card-content>
            <ordered-table table-header-color="orange"></ordered-table>
          </md-card-content>
        </md-card>
      </div>

      <div class="md-layout-item md-medium-size-100 md-xsmall-size-100 md-size-100"
           v-if="swarm_selected">
        <h1> Stats for stream: {{this.swarm_selected}} </h1>
      </div>



      <div class="md-layout-item md-medium-size-50 md-xsmall-size-100 md-size-50" v-if="swarm_selected">
          <chart-card
                :chart-data="SwarmByBrowser"
                :chart-options="emailsSubscriptionChart.options"
                :chart-responsive-options="emailsSubscriptionChart.responsiveOptions"
                :chart-type="'Bar'"
                data-background-color="green">
          <template slot="content">
            <h4 class="title">Browsers</h4>

          </template>

          <template slot="footer">
            <div class="stats">
              percentage of p2p/Http
            </div>
          </template>
        </chart-card>

      </div>

      <div class="md-layout-item md-medium-size-50 md-xsmall-size-100 md-size-50" v-if="swarm_selected">
        <chart-card
                :chart-data="SwarmByCountry"
                :chart-options="SwarmCountryOptions"
                :chart-responsive-options="emailsSubscriptionChart.responsiveOptions"
                :chart-type="'Bar'"
                data-background-color="green"
        >
          <template slot="content">
            <h4 class="title">Countries</h4>

          </template>

          <template slot="footer">
            <div class="stats">
            Gigabyte of Transfer
            </div>
          </template>
        </chart-card>
      </div>

      <div class="md-layout-item md-medium-size-50 md-xsmall-size-100 md-size-50" v-if="swarm_selected">
          <chart-card
                :chart-data="SwarmByTrackers"
                :chart-options="emailsSubscriptionChart.options"
                :chart-responsive-options="emailsSubscriptionChart.responsiveOptions"
                :chart-type="'Bar'"
                data-background-color="blue">
          <template slot="content">
            <h4 class="title">Trackers</h4>

          </template>

          <template slot="footer">
            <div class="stats">
            percentage of p2p/Http
            </div>
          </template>
        </chart-card>

      </div>

      <div class="md-layout-item md-medium-size-50  md-xsmall-size-100 md-size-50" v-if="swarm_selected">
        <chart-card
                :chart-data="SwarmByPlatform"
                :chart-options="emailsSubscriptionChart.options"
                :chart-responsive-options="emailsSubscriptionChart.responsiveOptions"
                :chart-type="'Bar'"
                data-background-color="blue">
          <template slot="content">
            <h4 class="title">Platforms</h4>
          </template>
          <template slot="footer">
            <div class="stats">
              percentage of p2p/Http
            </div>
          </template>
        </chart-card>
      </div>

      <div class="md-layout-item md-medium-size-25 md-xsmall-size-100 md-size-25" v-if="swarm_selected">
        <chart-card
                :chart-data="SwarmBrowserOnWin32"
                :chart-options="emailsSubscriptionChart.options"
                :chart-responsive-options="emailsSubscriptionChart.responsiveOptions"
                :chart-type="'Bar'"
                data-background-color="green">
          <template slot="content">
            <h4 class="title">Browsers On Win32</h4>
            <div v-for="browser in this.swarm_browser_on_win32">
              <code>{{browser['browsername']}} has {{browser['clients']}} peers </code>
            </div>
          </template>
          <template slot="footer">
            percentage of p2p/Http
          </template>
        </chart-card>
      </div>

      <div class="md-layout-item md-medium-size-25 md-xsmall-size-100 md-size-25" v-if="swarm_selected">
        <chart-card
                :chart-data="SwarmBrowserOnWin64"
                :chart-options="emailsSubscriptionChart.options"
                :chart-responsive-options="emailsSubscriptionChart.responsiveOptions"
                :chart-type="'Bar'"
                data-background-color="cyan">
          <template slot="content">
            <h4 class="title">Browsers On Win64</h4>
            <div v-for="browser in this.swarm_browser_on_win64">
              <code>{{browser['browsername']}} has {{browser['clients']}} peers </code>
            </div>
          </template>
          <template slot="footer">
            percentage of p2p/Http

          </template>
        </chart-card>
      </div>

      <div class="md-layout-item md-medium-size-25 md-xsmall-size-100 md-size-25" v-if="swarm_selected">
        <chart-card
                :chart-data="SwarmBrowserOnMacIntel"
                :chart-options="emailsSubscriptionChart.options"
                :chart-responsive-options="emailsSubscriptionChart.responsiveOptions"
                :chart-type="'Bar'"
                data-background-color="cyan">
          <template slot="content">
            <h4 class="title">Browsers On MacIntel</h4>
            <div v-for="browser in this.swarm_browser_on_macintel">
              <code>{{browser['browsername']}} has {{browser['clients']}} peers </code>
            </div>
          </template>
          <template slot="footer">
            percentage of p2p/Http
          </template>
        </chart-card>
      </div>

       <div class="md-layout-item md-medium-size-25 md-xsmall-size-100 md-size-25" v-if="swarm_selected">
        <chart-card
                :chart-data="SwarmBrowserOnLinux"
                :chart-options="emailsSubscriptionChart.options"
                :chart-responsive-options="emailsSubscriptionChart.responsiveOptions"
                :chart-type="'Bar'"
                data-background-color="green">
          <template slot="content">
            <h4 class="title">Browsers On Linux</h4>
            <div class="stats" v-for="browser in this.swarm_browser_on_linux">
              <code>{{browser['browsername']}} has {{browser['clients']}} peers </code>
            </div>

          </template>
          <template slot="footer">
            <div class="stats">
            percentage of p2p/Http
            </div>

          </template>
        </chart-card>
      </div>
    </div>
  </div>
</template>

<script>
    import {
        StatsCard,
        ChartCard,
        OrderedTable
    } from "@/components";
    import { mapGetters } from "vuex";
    import {API} from '../services'

    export default {
        components: {
            StatsCard,
            ChartCard,
            OrderedTable
        },
        data() {
            return {
                intervals : [],
                swarm_selected: null,
                swarm_trackers:[],
                swarm_browser: [],
                swarm_country:[],
                swarm_platform: [],
                swarm_browser_on_win32:[],
                swarm_browser_on_win64:[],
                swarm_browser_on_macintel:[],
                swarm_browser_on_linux:[],
                people: [],
                people_by_user: 0,
                abc: [],
                emailsSubscriptionChart: {

                    options: {
                        axisX: {
                            showGrid: false
                        },
                        low: 0,
                        high: 120,
                        chartPadding: {
                            top: 1,
                            right: 5,
                            bottom: 0,
                            left: 0
                        }
                    },
                    responsiveOptions: [
                        [
                            "screen and (max-width: 640px)",
                            {
                                seriesBarDistance: 5,
                                axisX: {
                                    labelInterpolationFnc: function (value) {
                                        return value[0];
                                    }
                                }
                            }
                        ]
                    ]
                }
            };
        },

        computed: {
            ...mapGetters(["is_authenticated","is_staff","get_userdata","get_sources"]),                    
            PeopleOnlineOptions: function () {
                let people = this.people.slice(0).reverse().map(row => row['people'])
                people = people.slice(people.length - 250, people.length - 1)
                let max = 0;
                for (var i = 0; i < people.length; i++) {
                    if (max < parseInt(people[i])) {
                        max = parseInt(people[i])
                    } //don't forget to add the base
                }
                //let avg = sum / people.length;
                return {
                    lineSmooth: this.$Chartist.Interpolation.cardinal({
                        tension: 0
                    }),
                    low: 0,
                    high: max + 5000,
                    chartPadding: {
                        top: 0,
                        right: 0,
                        bottom: 0,
                        left: 20
                    }
                }

            },

            PeopleOnline: function () {
                let labels = this.people.slice(0).reverse().map(row => null)
                let people = this.people.slice(0).reverse().map(row => row['people']);
                return ({
                    labels: labels.slice(labels.length - 250, labels.length - 1),
                    series: [people.slice(people.length - 250, people.length - 1)]
                })

            },
                 
            SwarmCountryOptions:function(){
                 let p2p = this.swarm_country.map(row => row['p2p'] / 1024 / 1024 / 1024);
                let max = 0;
                for (var i = 0; i < p2p.length; i++) {
                    if (max < parseInt(p2p[i])) {
                        max = parseInt(p2p[i])
                    }
                }


                return {
                    axisX: {
                        showGrid: false
                    },
                    low: 0,
                    high: max * 1.3,
                    chartPadding: {
                        top: 1,
                        right: 5,
                        bottom: 0,
                        left: 20
                    }
                }

            },

            SwarmByTrackers:function () {
                let p2p = this.swarm_trackers.map(row => row['p2p']);
                let http = this.swarm_trackers.map(row => row['http']);
                return ({
                    labels: this.swarm_trackers.map(row => row['ssl']),
                    series: [p2p, http]
                })
            },
            SwarmByBrowser(){

                let p2p = this.swarm_browser.map(row => row['p2p']);
                let http = this.swarm_browser.map(row => row['http']);
                return ({
                    labels: this.swarm_browser.map(row => row['browsername']),
                    series: [p2p, http]
                })
            },
            SwarmByCountry(){

                let countries = this.swarm_country.map(row => row['country']);
                let p2p = this.swarm_country.map(row => row['p2p'] / 1024 / 1024 / 1024);
                let http = this.swarm_country.map(row => row['http'] / 1024 / 1024 / 1024);
                return {
                    labels: countries,
                    series: [p2p, http]
                }

            },
            SwarmByPlatform(){
                let p2p = this.swarm_platform.map(row => row['p2p']);
                let http = this.swarm_platform.map(row => row['http']);

                return {
                    labels: this.swarm_platform.map(row => row['platform']),
                    series: [p2p, http]
                }
            },
            SwarmBrowserOnWin32() {
                let p2p = this.swarm_browser_on_win32.map(row => row['p2p']);
                let http = this.swarm_browser_on_win32.map(row => row['http']);
                return ({
                    labels: this.swarm_browser_on_win32.map(row => row['browsername']),
                    series: [p2p, http]
                })
            },
            SwarmBrowserOnWin64() {
                let p2p = this.swarm_browser_on_win64.map(row => row['p2p']);
                let http = this.swarm_browser_on_win64.map(row => row['http']);
                return ({
                    labels: this.swarm_browser_on_win64.map(row => row['browsername']),
                    series: [p2p, http]
                })
            },
            SwarmBrowserOnMacIntel() {
                let p2p = this.swarm_browser_on_macintel.map(row => row['p2p']);
                let http = this.swarm_browser_on_macintel.map(row => row['http']);
                return ({
                    labels: this.swarm_browser_on_macintel.map(row => row['browsername']),
                    series: [p2p, http]
                })
            },
            SwarmBrowserOnLinux() {
                let p2p = this.swarm_browser_on_linux.map(row => row['p2p']);
                let http = this.swarm_browser_on_linux.map(row => row['http']);
                return ({
                    labels: this.swarm_browser_on_linux.map(row => row['browsername']),
                    series: [p2p, http]
                })
            }

        },
        created: function () {


            if (this.is_authenticated){
              API.getClientSum().then(
                  response => {
                    this.total = response.data
                  },
              );

            } else {
                this.$router.push("login")
              }
            
            if (this.is_authenticated && this.is_staff==false ){
              this.updatePeopleOnlineByClient();
              this.intervals.push(window.setInterval(this.updatePeopleOnlineByClient, 60000));
            }
            else{
              this.updatePeopleOnline();
            this.intervals.push(window.setInterval(this.updatePeopleOnline, 60000));
            }

        },
        beforeDestroy() {
            this.intervals.forEach(function (interval) {
                window.clearInterval(interval)
            });




        },
        methods: {

        
            updatePeopleOnlineByClient: function() {
              API.getPeopleOnlineByClien().then(
                    response => {
                        this.people_by_user = response.data
                    },
                );
            },
            updatePeopleOnline: function () {
                API.getPeopleOnline().then(
                    response => {
                        this.people = response.data
                    },
                );

            },
          
            updateSwarmByTrackers: function () {
                API.getSwarmByTrackers(this.swarm_selected).then(
                    response => {
                        this.swarm_trackers = response.data
                    });
            },
            updateSwarmByBrowser: function () {
                API.getSwarmByBrowsername(this.swarm_selected).then(
                    response => {
                        this.swarm_browser = response.data
                    });


            },
            updateSwarmByCountry: function () {
                API.getSwarmByCountry(this.swarm_selected).then(
                    response => {
                        this.swarm_country = response.data
                    });


            },
            updateSwarmByPlatform: function () {
                API.getSwarmByPlatform(this.swarm_selected).then(
                    response => {
                        this.swarm_platform = response.data
                    });


            },
            updateSwarmByBrowserOnWin32: function () {
                API.getSwarmByBrowsernameOnWin32(this.swarm_selected).then(
                    response => {
                        this.swarm_browser_on_win32 = response.data
                    });


            },
            updateSwarmByBrowserOnWin64: function () {
                API.getSwarmByBrowsernameOnWin64(this.swarm_selected).then(
                    response => {
                        this.swarm_browser_on_win64 = response.data
                    });


            },
            updateSwarmByBrowserOnMacIntel: function () {
                API.getSwarmByBrowsernameOnMacIntel(this.swarm_selected).then(
                    response => {
                        this.swarm_browser_on_macintel = response.data
                    });


            },
            updateSwarmByBrowserOnLinux: function () {
                API.getSwarmByBrowsernameOnLinux(this.swarm_selected).then(
                    response => {
                        this.swarm_browser_on_linux = response.data
                    });


            },


        }
    };
</script>
